import { render, staticRenderFns } from "./ChatUser.CarouselItem.vue?vue&type=template&id=33e446a2&scoped=true&"
import script from "./ChatUser.CarouselItem.vue?vue&type=script&lang=js&"
export * from "./ChatUser.CarouselItem.vue?vue&type=script&lang=js&"
import style0 from "./ChatUser.CarouselItem.vue?vue&type=style&index=0&id=33e446a2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e446a2",
  null
  
)

export default component.exports